import React, { useContext, useState } from "react";
import { createContext } from "react";
import { useStateSessionStorage } from "../../hooks/useStateSessionStorage";
import { Box } from "@mui/material";
import { AddTaskMenItemModel } from "../../components/addTaskMenuItem/AddTaskMenuItemContext.tsx";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export interface OverdueTasksModel {
    hasOverdueTasks: boolean;
    refetch: () => void;
}

export const OverdueTasksContext = createContext<OverdueTasksModel>({
    hasOverdueTasks: false,
    refetch: () => {},
});

export interface IOverdueTasksProviderProps {
    children: any;
}

export const useOverdueTasksContext = () => {
    return useContext(OverdueTasksContext);
};

export function OverdueTasksProvider(props: IOverdueTasksProviderProps) {
    let overdueTasksUrl = "/taskManagement/HasOverdueTasks";
    const { isLoading, data, refetch } = useDotLegalQuery<boolean>(overdueTasksUrl);

    const contextData: OverdueTasksModel = {
        hasOverdueTasks: isLoading ? false : data!,
        refetch: () => {
            refetch();
        },
    };

    return <OverdueTasksContext.Provider value={contextData}>{props.children}</OverdueTasksContext.Provider>;
}

export default OverdueTasksProvider;
